import services from '@/utils/request';





// 绑定店铺列表
export function list(parms) {

    return services.request({
        method: 'GET',
        url: `/shop/binding/list?pageSize=${parms.pageSize}&pageNum=${parms.pageNum}&orderByColumn=${parms.orderByColumn}&isAsc=${parms.isAsc}&source=${parms.source}`,

    })
}
// 绑定店铺

export function binding(parms) {
    return services.request({
        method: 'PATCH',
        url: `/shop/binding/${parms.shopCode}`,
      
    })
}

// 解绑店铺



export function bindingOne(params) {
    let shopNumbersArray = []
    if (Array.isArray(params)) {
        shopNumbersArray = params
    } else if (params && Array.isArray(params.shopNumber)) {
        shopNumbersArray = params.shopNumber
    } else if (params && Array.isArray(params.shopNumbers)) {
        shopNumbersArray = params.shopNumbers
    } else if (typeof params === 'string' || typeof params === 'number') {
        shopNumbersArray = [params]
    } else if (params && params.shopNumber !== undefined) {
        shopNumbersArray = [params.shopNumber]
    } else if (params && params.shopNumbers !== undefined) {
        shopNumbersArray = [params.shopNumbers]
    }
    const shopNumber = shopNumbersArray.join(',')
    return services.request({
        method: 'DELETE',
        url: `/shop/binding/${shopNumber}`,
    })
}


// 地址列表


export function addressList(params) {
    return services.request({
        method: 'GET',
        url: "/address/list",
        params:params
    })
}

// 新增地址

export function add(params) {
    return services.request({
        method: 'POST',
        url: "/address/add",
        data:params
    })
}
// 获取区域


export function areas(params) {
    return services.request({
        method: 'GET',
        url: "/address/areas",
        params:params
    })
}

// 编辑地址
export function address(params) {
    return services.request({
        method: 'PUT',
        url: "/address",
        data:params
    })
}
// s删除地址
export function addressDelete(params) {
    return services.request({
        method: 'DELETE',
        url: `/address/${params.addressIds}`,
     
    })
}

// 设置默认地址
export function addressMo(params) {
    return services.request({
        method: 'PATCH',
        url: `/address/${params.addressId}`,
     
    })
}

// 设置常用地址
export function updateDeliverContents(params) {
    return services.request({
        method: 'POST',
        url: "/deliver/updateDeliverContents",
        data:params
     
    })
}

// 获取用户配置列表
export function getUserConfig(params) {
    return services.request({
        method: 'GET',
        url: "/shop/config/",
   
     
    })
}

export function manually(params) {
    return services.request({
        method: 'POST',
        url: "/shop/binding/refresh/manually",
        data: params
     
    })
}

// 
export function refresh(shopNumber) {
    return services.request({
        method: 'GET',
        url: `/shop/binding/refresh/${shopNumber}`,
     
     
    })
}
// 删除面单
export function deletePrintTemplate(shopNumber) {
    return services.request({
        method: 'DELETE',
        url: `/ship/printTemplate/deletePrintTemplate/${shopNumber}`,
     
     
    })
}

export function listOne(parms) {

    return services.request({
        method: 'GET',
        url: `/shop/binding/list?pageSize=${parms.pageSize}&pageNum=${parms.pageNum}&orderByColumn=${parms.orderByColumn}&isAsc=${parms.isAsc}&source=${parms.source}`,
     

    })
}

// 店铺授权
export function getShopAuthUrl(params) {
    return services.request({
        method: 'GET',
        url: `/auth/getShopAuthUrl/${params.callback}/${params.type}`,


    })
}

// 订单同步
export function sync(data, head) {
    return services.request({
        method: 'POST',
        url: "/sync/v2/order",
        data: data,
        headers: {
            "Shop-Numbers": head
        }
    })
}


// 订单同步进度sync

export function getSyncProgressLog(data) {
    return services.request({
        method: 'GET',
        url: '/sync/v2/progress',
    })

}

// 获取销售店铺自动采购配置项详细信息

export function salesShopAutoConfig(data) {
    return services.request({
        method: 'GET',
        url: `/shop/config/${data.shopNumber}`,
    })

}

// 新增销售店铺自动采购配置项

export function AddSalesShopAutoConfig(data) {
    return services.request({
        method: 'POST',
        url: "/purchase/salesShopAutoConfig",
        data:data
    })

}
// 修改销售店铺自动采购配置项


export function upDataShopAutoConfig(data) {
    return services.request({
        method: 'POST',
        url: "/shop/config/update",
        data:data
    })

}

// 获取自动采购账号配置项详细信息



export function purchaseShopAutoConfig(data) {
    return services.request({
        method: 'GET',
        url: `/purchase/purchaseShopAutoConfig/${data.shopNumber}`,
    })

}
//新增自动采购账号配置项

export function AddPurchaseShopAutoConfig(data) {
    return services.request({
        method: 'POST',
        url: "/purchase/purchaseShopAutoConfig",
        data:data
    })

}

// 修改自动采购账号配置项

export function updataPurchaseShopAutoConfig(data) {
    return services.request({
        method: 'PUT',
        url: "/purchase/purchaseShopAutoConfig",
        data:data
    })

}

// 1688认证

export function getAuthUrl(parms) {
  return services.request({
    method: "GET",
    url: "/auth/getShopAuthBindUrl",
    params: parms,
  });
}